/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import {ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild,} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators,} from '@angular/forms';
import {AccountResourceService, AuthServerProvider, LoginService, PrincipalService,} from '../../../shared';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {HomeService} from '../services/home.service';
import {Profile} from '../../../shared/types/profile.type';
import {AccountType} from '../../../shared/types/account.type';
import {Idle} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import {DocumentResourceService} from '../../../shared/services/document-resource.service';
import {BsModalComponent} from 'ng2-bs3-modal';
import {ROLE_CONSTANTS} from '../../../shared/constants/constant';
import {TokenService} from '../../../shared/services/token.service';

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  public authenticationError: boolean;
  public successAuthentication: boolean = false;
  public password: string;
  public username: string;
  public isAdmin: boolean = false;
  public isEmployee: boolean = false;
  public isEmployer: boolean = false;
  public auth: boolean = false;
  public emptySearchParam;
  public invalidSearchParam;
  public searchString = null;
  public profile: Profile;
  public accountDetails;
  public account: AccountType;
  public showProfile: boolean = false;
  public userDetails;
  public userFound: boolean = false;
  public userNotFound: boolean = false;
  public userSearch: boolean = true;
  idleState = "Not started.";
  timedOut = false;
  lastPing: Date = null;
  public userSearchForm = new FormGroup({
    certificateNumber: new FormControl("", Validators.required),
  });
  public certificateNumber: AbstractControl =
    this.userSearchForm.get("certificateNumber");
  public serverError: boolean = false;

  @ViewChild("otpModal")
  otpModal: BsModalComponent;

  @ViewChild("registerDeviceModal")
  registerDeviceModal: BsModalComponent;

  @ViewChild("thankYouModal")
  thankYouModal: BsModalComponent;

  @ViewChild("introModal")
  introModal: BsModalComponent;

  otpUserEmail: string;

  form: FormGroup;


  constructor(
    public principal: PrincipalService,
    public loginService: LoginService,
    public tokenService: TokenService,
    public homeService: HomeService,
    private accountResourceService: AccountResourceService,
    private documentResourceSerive: DocumentResourceService,
    private translate: TranslateService,
    private idle: Idle,
    private keepalive: Keepalive,
    private changeDetector: ChangeDetectorRef,
    public authServerProvider: AuthServerProvider,
    public router: Router,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.principal.identity(true).then(
      (account) => {
        if (!account) {
          this.router.navigate(["login"]);
          this.serverError = true;
        } else if (account) {
          this.account = account;
          this.serverError = false;
          let role = this.account["authorities"][0];
          if (
            role == ROLE_CONSTANTS.ROLE_ADMIN ||
            role == ROLE_CONSTANTS.ROLE_EMPLOYER||
            role == ROLE_CONSTANTS.ROLE_SUPPORT
          ) {
            this.isAdmin = true;
          } else if (role == ROLE_CONSTANTS.ROLE_EMPLOYEE) {
            this.isEmployee = true;
          } else if (this.account == null) {
            this.router.navigate(["login"]);
            this.serverError = true;
          }
        }
      },
      (error) => {
        this.serverError = true;
        this.router.navigate(["login"]);
      }
    );
  }

  ngOnInit() {
    this.loadProfile();
    this.checkIfDeviceRegistered();
  }

  ngAfterViewInit() {}

  checkIfDeviceRegistered() {
    // const token = localStorage.getItem("token");
    const token = this.tokenService.secureGet("token");
    this.homeService.checkIfDeviceRegistered(token).subscribe( (res: any) => {
      const response = res.replyMessageList[0];
      if (
        response.isRegistered == false &&
        response.isFirstTimeLogin == false
      ) {
        this.registerDeviceModal.open();
      } else if (
        response.isRegistered == false &&
        response.isFirstTimeLogin == true
      ) {
        this.introModal.open();
      } else {
      }
    });
  }


  registerDeviceButton(answer: number) {
    // const token = localStorage.getItem("token");
    const token = this.tokenService.secureGet("token");
    if (answer === 0) {
      this.registerDeviceModal.close();
    } else if (answer === 1) {
      this.homeService.registerDevice(token).subscribe((res: any) => {
        if (res.statusCode === "AU000") {
          this.registerDeviceModal.close();
          this.thankYouModal.open();
        } else {
        }
      });
    }
  }

  thankYouButton() {
    this.thankYouModal.close();
  }

  introModalButton() {
    this.introModal.close();

  }



  public isAuthenticated() {
    return this.principal.isAuthenticated();
  }

  public login() {
    this.loginService
      .login({
        username: this.username,
        password: this.password,
      })
      .then(() => {
        this.reset();
        this.successAuthentication = true;
        this.authenticationError = false;
        this.isAuthenticated = this.isAuthenticated;
        this.auth = true;
        this.loadProfile();
      })
      .catch(() => {
        this.authenticationError = true;
      });
  }

  public reset() {
    this.idle.watch();
    this.idleState = "Started.";
    this.timedOut = false;
  }

  logout(timout) {
    this.account = null;
    this.principal.authenticate(null);
    this.loginService.logout(timout);
  }

  public loadProfile() {
    this.homeService.getProfile().subscribe((profile: Profile) => {
      this.profile = profile;
      /*      this.profile.dateOfBirth = moment(this.profile.dateOfBirth).format('DD MMM YYYY');
      this.profile.retirementDate = moment(this.profile.retirementDate).format('DD MMM YYYY');*/
    });
    this.searchString = null;

    const login = this.tokenService.secureGet("account").login;
    const token = this.tokenService.secureGet("token");

    this.homeService.getLogin(login,token).subscribe(
      data => {
        if (data.replyMessageList && data.replyMessageList.length > 0) {
          const response = data.replyMessageList[0];
          this.tokenService.secureSave("accountDetails", response);
        }
      });
  }

  public searchUserCeritificate() {
    this.userSearch = false;
    this.accountResourceService
      .searchByCertificateNumber(this.certificateNumber.value)
      .subscribe((data) => {
        this.userDetails = data["data"];
        if (data["data"] != null) {
          this.userFound = true;
          this.userNotFound = false;
        } else {
          this.userNotFound = true;
          this.userFound = false;
        }
      });
  }

  public downloadECertificateInit() {
    this.emptySearchParam = false;

    if (this.principal.hasAnyAuthority([ROLE_CONSTANTS.ROLE_EMPLOYEE])) {
      this.documentResourceSerive.getCertificate(true);
    } else if (
      this.principal.hasAnyAuthority([
        ROLE_CONSTANTS.ROLE_EMPLOYER,
        ROLE_CONSTANTS.ROLE_ADMIN
      ])
    ) {
      if (
        this.searchString !== null &&
        this.searchString !== undefined &&
        this.searchString !== ""
      ) {
        this.documentResourceSerive.getCertificateByKeyword(
          this.searchString,
          true
        );
      } else {
        this.emptySearchParam = true;
      }
    }
  }

  clearSearchData() {
    this.searchString = "";
    this.userSearch = true;
    this.userNotFound = false;
    this.userFound = false;
  }
}
